 
import { Injectable } from '@angular/core';
import {State, Action, StateContext, Selector} from '@ngxs/store';
import { timer } from 'rxjs';
import {tap, map, finalize} from 'rxjs/operators'
import { addBreadCrumb, clearAllBreadCrumb, clearBreadCrumb, Reset } from './breadcrum.action';
 
 export class stateModel{
    routerLink:string;
    queryParams:any;
    name:string;
    noRouting:boolean;
 }
export class BreadCrumbStateModel{
   routing:stateModel[]


}
@State<BreadCrumbStateModel>({
    name: 'BreadCrumb',
    defaults: {
        routing:[] 
     }
})
@Injectable()
export class BCState {

    constructor( ) {
    }

    @Selector()
    static getBCState(state: BreadCrumbStateModel) {
        return state;
    }
    
     

    // @Action(getLocationBreadCrumb)
    // getLocationBreadCrumb({getState, setState}: StateContext<BreadCrumbStateModel>,{}) {
    //     setState({
    //         location
    //     }) 
    // }

    @Action(addBreadCrumb)
    addBreadCrumb({getState, patchState}: StateContext<BreadCrumbStateModel>, {payload}: addBreadCrumb) {
        const state = getState();
        let route=[...state.routing,payload]
        // console.log(route)
        patchState({
            routing:route  
        });
    }
    @Action(clearAllBreadCrumb)
    clearAllBreadCrumb({getState, patchState}: StateContext<BreadCrumbStateModel>, {}: clearAllBreadCrumb) {
        const state = getState();
 
        patchState({
            routing:[]  
        });
    }

    @Action(clearBreadCrumb)
    clearBreadCrumb({getState, patchState}: StateContext<BreadCrumbStateModel>, {payload}: clearBreadCrumb) {
        const state = getState();
        const newState = JSON.parse(JSON.stringify(state));
        let route=newState.routing;
        route.length=payload
        // console.log(route)
        patchState({
            routing:route
        });
    }
    @Action(Reset)
    reset({ getState, setState}) {
      return timer(1000)
        .pipe(
          //tap(() => setState(0)),
          finalize(() => setState( {routing:[]  }))
        );
    }
}